module.exports = __webpack_public_path__ + "e6aabcefccc317c84c468a2753b60f28.png";